module.exports = __webpack_public_path__ + "img/auto-6.3000d8c6.png";